import { render, staticRenderFns } from "./YourSolutionTabComponent.vue?vue&type=template&id=4eede69d&scoped=true"
import script from "./YourSolutionTabComponent.vue?vue&type=script&lang=js"
export * from "./YourSolutionTabComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eede69d",
  null
  
)

export default component.exports